import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { BecomeACustomerState } from '@innogy/become-a-customer/state';
import { getUsageQuestionnaireFormState } from '@innogy/become-a-customer/state';
import {
  CommonUiSalesModule,
  UsageQuestionnaireProps,
} from '@innogy/common-ui/sales';
import { Store } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';

@Component({
  selector: 'wl-usage-questionnaire-container[rendering]',
  templateUrl: './usage-questionnaire-container.component.html',
  standalone: true,
  imports: [CommonModule, NgrxFormsModule, CommonUiSalesModule],
})
export class UsageQuestionnaireContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering!: UsageQuestionnaireProps;

  public readonly formState$ = this.store$.select(
    getUsageQuestionnaireFormState
  );

  constructor(private readonly store$: Store<BecomeACustomerState>) {}
}
